"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_client_1 = require("./base.client");
const cookie_container_1 = require("../cookie.container");
const token_storage_1 = require("../token.storage");
const errors_1 = require("../errors");
const models_1 = require("../models");
exports.SESSION_KEY = 'CS_SESSION_ID';
class AuthV2Client extends base_client_1.BaseClient {
    constructor() {
        super(...arguments);
        this.baseRoute = '/v2/auth';
    }
    authenticate(auth) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = { responseCookies: new cookie_container_1.CookieContainer(), throwOnError: false, withCredentials: true };
            const response = yield this.httpPost(`${this.baseRoute}/login`, auth, opts).catch(err => err);
            if (!response.success) {
                throw new errors_1.AuthFailedError(response);
            }
            token_storage_1.TokenStorage.store(response.payload.accessToken, undefined, '3');
            const cookie = opts.responseCookies.get('CS_SESSION_ID') || {};
            return Object.assign(Object.assign({}, response.payload), { sessionId: cookie.value });
        });
    }
    logout(accessToken, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = {
                throwOnError: false,
                withCredentials: true,
                headers: this.getHeaders({ accessToken, sessionId }),
            };
            const response = yield this.httpPost(`${this.baseRoute}/logout`, null, opts);
            if (response.success) {
                return response.payload;
            }
            return { result: models_1.LogoutResultStatus.UnknownError };
        });
    }
    createExchangeToken(accessToken, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = {
                withCredentials: true,
                headers: this.getHeaders({ accessToken, sessionId }),
                throwOnError: true,
            };
            const response = yield this.httpPost(`${this.baseRoute}/exchange/jwt`, null, opts);
            return response.payload;
        });
    }
    exchangeToken(exchangeToken, key, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = {
                withCredentials: true,
                headers: this.getHeaders({ sessionId }),
                throwOnError: false,
            };
            const response = yield this.httpPost(`${this.baseRoute}/exchange/jwt/${exchangeToken}`, {}, opts);
            if (!response.success) {
                throw new errors_1.AuthFailedError(response);
            }
            token_storage_1.TokenStorage.store(response.payload.accessToken, key, '3');
            return response.payload;
        });
    }
    refreshToken(accessToken, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = {
                withCredentials: true,
                headers: this.getHeaders({ accessToken, sessionId }),
                throwOnError: false,
            };
            const response = yield this.httpPost(`${this.baseRoute}/refresh`, {}, opts);
            return response.payload;
        });
    }
    getHeaders({ accessToken, sessionId }) {
        const headers = {};
        if (accessToken) {
            headers.authorization = `Bearer ${accessToken}`;
        }
        if (sessionId) {
            headers.cookie = `${exports.SESSION_KEY}=${sessionId}`;
        }
        return headers;
    }
    hasProvider(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = { responseCookies: new cookie_container_1.CookieContainer(), throwOnError: false, withCredentials: true };
            const response = yield this.httpGet(`${this.baseRoute}/sso/has-provider?email=${email}`, opts);
            if (!response.success) {
                throw new Error();
            }
            return response.payload;
        });
    }
}
exports.AuthV2Client = AuthV2Client;
//# sourceMappingURL=auth.v2.client.js.map